import React, { useState, useEffect, useCallback } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  ListItemIcon,
  Typography,
  Box
} from '@material-ui/core'
import { ButtonPrimary } from '../ButtonPrimary'
import { ButtonSecondary } from '../ButtonSecondary'
import { useStyles } from './styles'
import { Signal } from 'lucide-react'
import iconWhatsApp from '../../assets/whatsapp.svg'

const renderStatusIcon = (status, classes) => {
  const isConnected = status?.toLowerCase() === 'connected'

  return (
    <Signal
      className={
        isConnected
          ? classes.statusIconConnected
          : classes.statusIconDisconnected
      }
      size={18}
      aria-hidden="true"
    />
  )
}

const WhatsAppSelectionModal = ({
  open,
  onClose,
  whatsapps = [],
  selectedIds = [],
  onSave
}) => {
  const classes = useStyles()
  const [tempSelectedIds, setTempSelectedIds] = useState([])

  useEffect(() => {
    if (open) {
      const normalizedIds = selectedIds.map(id => Number(id))
      setTempSelectedIds(normalizedIds)
    }
  }, [selectedIds, open])

  const handleToggle = useCallback(id => {
    const targetId = Number(id)
    setTempSelectedIds(prev => {
      const isChecked = prev.includes(targetId)
      if (isChecked) {
        return prev.filter(item => item !== targetId)
      } else {
        return [...prev, targetId]
      }
    })
  }, [])

  const handleConfirm = () => {
    onSave(tempSelectedIds)
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      aria-labelledby="whatsapp-selection-title"
    >
      <DialogTitle id="whatsapp-selection-title">
        <Typography variant="h6" className={classes.dialogTitle}>
          Vincular Bot às Conexões
        </Typography>
        <Typography className={classes.description}>
          Selecione em quais conexões este bot deve responder.
        </Typography>
      </DialogTitle>

      <DialogContent dividers>
        {whatsapps.length === 0 ? (
          <Box p={3} textAlign="center">
            <Typography variant="body2" color="textSecondary">
              Nenhuma conexão disponível.
            </Typography>
          </Box>
        ) : (
          <List>
            {whatsapps.map(whats => {
              const whatsappId = Number(whats.id)
              const isChecked = tempSelectedIds.includes(whatsappId)

              return (
                <ListItem
                  key={whats.id}
                  button
                  onClick={() => handleToggle(whats.id)}
                  selected={isChecked}
                  className={classes.listItem}
                >
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={isChecked}
                      tabIndex={-1}
                      disableRipple
                      color="primary"
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="between"
                      >
                        <Box
                          display="flex"
                          alignItems="center"
                          gridGap={8}
                          style={{ gap: 8 }}
                        >
                          <Typography variant="body1" component="span">
                            {whats.name}
                          </Typography>

                          {/* Renderização Condicional dos Ícones do Canal */}
                          {whats.channel === 'whatsapp' && (
                            <img
                              src={iconWhatsApp}
                              alt="Canal WhatsApp"
                              style={{
                                width: 18,
                                height: 18,
                                display: 'block'
                              }}
                            />
                          )}

                          {whats?.channel === 'notificamehub' && (
                            <Box
                              display="flex"
                              alignItems="center"
                              style={{ gap: 4 }}
                            >
                              <img
                                src={iconWhatsApp}
                                alt="Canal NotificameHub"
                                style={{
                                  width: 18,
                                  height: 18,
                                  display: 'block'
                                }}
                              />
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                style={{ fontWeight: 'bold' }}
                              >
                                + API
                              </Typography>
                            </Box>
                          )}
                        </Box>

                        {/* Lado Direito: Ícone de Status (Sinal) */}
                        <Box display="flex" alignItems="center">
                          {renderStatusIcon(whats.status, classes)}
                        </Box>
                      </Box>
                    }
                  />
                </ListItem>
              )
            })}
          </List>
        )}
      </DialogContent>

      <DialogActions>
        <ButtonSecondary onClick={onClose} label="Cancelar" />
        <ButtonPrimary
          onClick={handleConfirm}
          label="Confirmar"
          disabled={whatsapps.length === 0}
        />
      </DialogActions>
    </Dialog>
  )
}

export default WhatsAppSelectionModal
